import { Skeleton } from '@mui/material'

import { EventAssetsLoading } from '../generic-event-assets-table/Loading'
import classes from './index.module.scss'

export const Loading = () => (
  <div className={classes.root}>
    <ul className={classes.list}>
      <Skeleton className="mb-half" height="53px" variant="rectangular" width="240px" />
      <Skeleton className="mb-half" height="53px" variant="rectangular" width="240px" />
      <Skeleton className="mb-half" height="53px" variant="rectangular" width="240px" />
    </ul>
    <div className={classes.details}>
      <header>
        <Skeleton height="24px" variant="text" width="200px" />
      </header>

      <nav className="d-flex">
        <Skeleton className="mr-1" height="20px" variant="rectangular" width="80px" />
        <Skeleton className="mr-1" height="20px" variant="rectangular" width="80px" />
        <Skeleton className="mr-1" height="20px" variant="rectangular" width="80px" />
      </nav>

      <div className="mt-10">
        <EventAssetsLoading />
      </div>
    </div>
  </div>
)
